import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";

import { sampleData } from "./SampleData";

import { parseQueryResultToCommonResult } from '../utils/helper';

export default class Model extends ModelDataSourcePropertyBase {

    script = new PropertyDescriptor(`data = ${JSON.stringify(sampleData, null, "    ")}`, '使用 Javascript 创建数据', "高级", "js", "#anticon-Documentation", {
        description: '在数据逻辑较复杂的情况下，您可以采用 Javascript 脚本来创建数据',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    loadData(opts) {

        return new Promise((resolve, reject) => {
            if (!opts.runScript) {
                reject(new Error("执行脚本的方法未初始化"));
                return;
            }

            const result = opts.runScript(this.script, opts.data, undefined, undefined, { throwException: true });
            if (!(result instanceof Promise)) {
                resolve(parseQueryResultToCommonResult(result));
                return;
            }

            result.then(data => {
                resolve(parseQueryResultToCommonResult(data));
            }, err => {
                reject(err);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
